import React from 'react'
import { useSelector } from 'react-redux'
import { selectTopGainers5, selectTopLosers5 } from '../../core/reducers/markets'
import { selectDefiCoins5 } from '../../core/reducers/defi'
import { Lock, OutlinedDown, OutlinedUp } from '../Icon'

import OverviewTopCoins from './OverviewTopCoins'
import OverviewTvlChange from './OverviewTvlChange'

function OverviewSpotlight() {
  const topGainers = useSelector(state => selectTopGainers5(state))
  const topLosers = useSelector(state => selectTopLosers5(state))
  const tvlGainers = useSelector(state => selectDefiCoins5(state))

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
      <div>
        <OverviewTopCoins tokens={topGainers} title="Top gainers" headIcon={OutlinedUp} seeMorePath="/top-gainers" />
      </div>
      <div>
        <OverviewTopCoins tokens={topLosers} title="Top losers" headIcon={OutlinedDown} seeMorePath="/top-losers" />
      </div>
      <div>
        <OverviewTvlChange tokens={tvlGainers} title="TVL change" headIcon={Lock} seeMorePath="/defi-tvl" />
      </div>
    </div>
  )
}

export default OverviewSpotlight
